// Getters
export const GET_ORDERS = "orders/GET_ORDERS";
export const GET_ORDER = "orders/GET_ORDER";

// Mutations
export const MUTATE_LOAD_ORDERS = "orders/MUTATE_LOAD_ORDERS";
export const MUTATE_ADD_ORDER = "orders/MUTATE_ADD_ORDER";
export const MUTATE_UPDATE_ORDER = "orders/MUTATE_UPDATE_ORDER";
export const MUTATE_DELETE_ORDER = "orders/MUTATE_DELETE_ORDER";

// Actions
export const ACTION_GET_ORDERS = "orders/ACTION_GET_ORDERS";
export const ACTION_GET_ORDER = "orders/ACTION_GET_ORDER";
export const ACTION_ADD_ORDER = "orders/ACTION_ADD_ORDER";
export const ACTION_UPDATE_ORDER = "orders/ACTION_UPDATE_ORDER";
export const ACTION_DELETE_ORDER = "orders/ACTION_DELETE_ORDER";
export const ACTION_DOWNLOAD_ORDERING_PDF_PERSON = "orders/ACTION_DOWNLOAD_ORDERING_PDF_PERSON";
export const ACTION_DOWNLOAD_ORDERING_PDF_PERSONGROUP = "orders/ACTION_DOWNLOAD_ORDERING_PDF_PERSONGROUP";
export const ACTION_GENERATE_ORDERING_PDF_AGREEMENT = "orders/ACTION_DOWNLOAD_ORDERING_PDF_PERSONGROUP";
export const ACTION_GENERATE_ORDERING_PDF_ALLPERSONGROUPS = "orders/ACTION_GENERATE_ORDERING_PDF_ALLPERSONGROUPS";
export const ACTION_GENERATE_ORDERING_PDF_PERSONGROUP = "orders/ACTION_GENERATE_ORDERING_PDF_PERSONGROUP";
export const ACTION_GENERATE_ORDERING_PDF_PERSON = "orders/ACTION_GENERATE_ORDERING_PDF_PERSON";
export const ACTION_GET_PERSON_ORDERINFORMATION = "orders/ACTION_GET_PERSON_ORDERINFORMATION";
export const ACTION_GET_ORDERS_BY_PERSONGROUP = "orders/ACTION_GET_ORDERS_BY_PERSONGROUP";
export const ACTION_SEND_WEBSHOPLINK_TO_CLIENT = "orders/ACTION_SEND_WEBSHOPLINK_TO_CLIENT";
export const ACTION_SEND_WEBSHOPLINKS_TO_CLIENTS = "orders/ACTION_SEND_WEBSHOPLINKS_TO_CLIENTS";
export const ACTION_SEND_NEW_WEBSHOPCODE_TO_CLIENT = "orders/ACTION_SEND_NEW_WEBSHOPCODE_TO_CLIENT";
export const ACTION_SEND_RECEIPT_TO_CLIENT = "orders/ACTION_SEND_RECEIPT_TO_CLIENT";
export const ACTION_SEND_PAYMENTLINK_TO_CLIENT = "orders/ACTION_SEND_PAYMENTLINK_TO_CLIENT";
export const ACTION_FIND_ORDERS = "orders/ACTION_FIND_ORDERS";
export const ACTION_CREATE_ORDERCOPY = "orders/ACTION_CREATE_ORDERCOPY";
export const ACTION_SEND_PAYMENTREMINDER_TO_CLIENT = "orders/ACTION_SEND_PAYMENTREMINDER_TO_CLIENT";

// Generated file actions. Should be moved to seperate "Files" module.
export const ACTION_GET_GENERATED_FILES = "orders/ACTION_GET_GENERATED_FILES";
export const ACTION_DOWNLOAD_GENERATED_FILE = "orders/ACTION_DOWNLOAD_GENERATED_FILE";
